import React from "react";
import Newsletter_44 from "../component/Newsletter_44";

function Newsletter_44_container() {
  return <Newsletter_44 />;
}

export default Newsletter_44_container;
